import React from "react";
import { LegalLayout, Section } from "../components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="June 2026" testid="privacy-page">
      <Section heading="Overview">
        NarcCheck AI ("we", "us") helps you analyse conversations for manipulation and narcissistic
        behaviour patterns. This policy explains what we collect, why, and the choices you have. We
        designed the product to collect as little as possible.
      </Section>

      <Section heading="Information we collect">
        <ul style={{ margin: 0, paddingLeft: 20 }}>
          <li><b>Conversation content you submit</b> — text, screenshots, or voice recordings you
            choose to analyse. This is sent to our AI provider to generate your scorecard.</li>
          <li><b>Analysis results you save</b> — if you tap "Save to History", the scorecard (scores,
            traits, quotes, verdict) is stored so you can revisit it.</li>
          <li><b>Account information</b> — if you sign in with Google, we store your email, name, and
            profile picture to identify your account and sync your history.</li>
          <li><b>A device identifier</b> — anonymous users get a random id stored in your browser so
            your history and free-usage count work before you sign in.</li>
          <li><b>Payment information</b> — handled entirely by Stripe. We never see or store your card
            details; we only keep a record of your subscription status.</li>
        </ul>
      </Section>

      <Section heading="How we use your information">
        We use your data only to provide the service: generating analyses, saving and syncing your
        history, managing your subscription, and keeping the app secure. We do not sell your personal
        information, and we do not use your conversations to train our own models.
      </Section>

      <Section heading="Voice recordings">
        Voice notes are transcribed to text and then analysed. The audio is processed transiently to
        produce a transcript and is not retained after transcription.
      </Section>

      <Section heading="Third parties">
        We rely on a small number of processors to run the service: an AI provider for analysis and
        transcription, Stripe for payments, and Google for optional sign-in. Each receives only what
        is needed to perform its function.
      </Section>

      <Section heading="Data retention & your rights">
        Your saved history stays until you delete individual items or your account. Deleting your
        account from Settings permanently removes your saved scorecards and signs you out everywhere.
        You can use the app anonymously without an account at any time.
      </Section>

      <Section heading="Security">
        Access to your saved history requires your session token (or, when anonymous, your device id).
        We take reasonable technical measures to protect your data, but no system is perfectly secure.
      </Section>

      <Section heading="Important disclaimer">
        NarcCheck AI is for personal reflection and entertainment only. It is not a medical or
        psychological assessment and must not be used to diagnose anyone.
      </Section>

      <Section heading="Contact">
        Questions about privacy? Email{" "}
        <a className="link" href="mailto:Goldenknee@gmail.com">Goldenknee@gmail.com</a>.
      </Section>
    </LegalLayout>
  );
}
